<template>
  <div class="d-flex flex-column w-100 h-100 px-2">
    <div class="d-flex flex-row">
      <div class="col-6">
        <b-button @click="onExportLayout" variant="light" class="sidebar-button">
          {{ $lang.PCI.Spreadsheet.SideBar.Export }}
        </b-button>
      </div>
      <div class="col-6">
        <b-button @click="$refs.readLayout.click()" variant="light" class="sidebar-button">
          {{ $lang.PCI.Spreadsheet.SideBar.Import }}
        </b-button>
      </div>
    </div>

    <span class="sidebar-separator">Layouts</span>

    <div class="d-flex flex-row w-100 pt-2 px-2 align-items-center" v-for="(layout, index) in layoutList" :key="index">
      <b-form-input lazy @change="onSaveLayout(index)" :placeholder="$lang.PCI.Spreadsheet.SideBar.PlaceholderName" v-model="layout.nome" class="mr-2"></b-form-input>
      <i class="fas fa-trash text-danger p-1" @click="onRemoveLayout(index)"></i>
      <i class="fas fa-filter text-secondary p-1" @click="onLoadFilter(index)" v-b-tooltip.hover :title="$lang.PCI.Spreadsheet.SideBar.LoadFilter"></i>
      <i class="fas fa-columns text-third p-1" @click="onLoadLayout(index)" v-b-tooltip.hover :title="$lang.PCI.Spreadsheet.SideBar.LoadLayout"></i>
    </div>

    <b-form-input lazy @change="onNewLayout" :placeholder="$lang.PCI.Spreadsheet.SideBar.PlaceholderName" v-model="newLayout.nome" class="mt-3"></b-form-input>

    <input type="file" ref="readLayout" @input="onImportLayout" style="display: none;" accept=".lyt">
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LayoutPciRepository from '@/shared/http/repositories/pci/layoutpci.js'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'LayoutSidebar',
  data () {
    return {
      pciId: {},
      layoutList: [],
      newLayout: {},
      filter: {},
      layout: {}
    }
  },
  computed: {
    ...mapGetters('auth', ['userInfo'])
  },
  methods: {
    onLoad (pciId) {
      this.pciId = pciId
      this.filter = JSON.stringify(this.params.api.getFilterModel())
      this.layout = JSON.stringify(this.params.columnApi.getColumnState())

      LayoutPciRepository.GetAll(this.pciId[0])
        .then(response => {
          if (response.data.code > 0) {
            this.layoutList = response.data.data
            this.onClear()
          } else {
            toast.error(this.$lang.Common.ActionNotTaken)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.ActionNotTaken)
        })
    },
    onClear () {
      this.$nextTick(() => {
        this.newLayout = {
          id: '00000000-0000-0000-0000-000000000000',
          nome: '',
          layout: this.layout,
          filtro: this.filter,
          pciID: null,
          contaID: this.userInfo.id
        }
      })
    },
    onNewLayout () {
      if (this.pciId) {
        let data = null
        this.pciId.forEach(pciID => {
          this.newLayout.pciID = pciID
          LayoutPciRepository.Create(this.newLayout)
            .then(response => {
              if (response.data.code > 0) {
                if (data == null) {
                  data = response.data.data
                  this.layoutList.push(data)
                }
                this.onClear()
              } else {
                toast.error(this.$lang.Common.CouldNotSave)
              }
            })
            .catch(err => {
              console.log(err)
              toast.error(this.$lang.Common.CouldNotSave)
            })
        })
      }
    },
    onSaveLayout (index) {
      LayoutPciRepository.Update(this.layoutList[index])
        .then(response => {
          if (response.data.code > 0) {
            this.$set(this.layoutList, index, response.data.data)
          } else {
            toast.error(this.$lang.Common.CouldNotSave)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.CouldNotSave)
        })
    },
    onRemoveLayout (index) {
      const h = this.$createElement
      let messageVNode = h('div', [
        h('h4', [
          this.layoutList[index].nome
        ]),
        h('br')
      ])
      this.$bvModal.msgBoxConfirm([messageVNode], {
        title: this.$lang.Common.ConfirmDelete,
        centered: true,
        okTitle: this.$lang.Common.Yes,
        okVariant: 'third',
        cancelTitle: this.$lang.Common.No,
        cancelVariant: 'danger',
        headerClass: 'justify-content-center'
      })
        .then((value) => {
          if (value) {
            LayoutPciRepository.Delete(this.layoutList[index].id)
              .then(response => {
                if (response.data.code > 0) {
                  this.layoutList.splice(index, 1)
                }
              })
              .catch(err => {
                console.log(err)
                toast.error(this.$lang.Common.CouldNotSave)
              })
          }
        })
    },
    onLoadFilter (index) {
      const filter = this.layoutList[index].filtro ? JSON.parse(this.layoutList[index].filtro) : {}
      this.params.api.setFilterModel(filter)
      this.params.api.closeToolPanel()
    },
    onLoadLayout (index) {
      if (this.layoutList[index].layout) {
        const layout = JSON.parse(this.layoutList[index].layout)
        this.params.columnApi.applyColumnState({ state: layout, applyOrder: false })
        this.params.api.closeToolPanel()
      }
    },
    onExportLayout () {
      const layout = JSON.stringify(this.params.columnApi.getColumnState())
      const blob = new Blob([layout], { type: 'text/plain;charset=utf-8;' })
      try {
        window.showSaveFilePicker({
          suggestedName: 'layout.lyt',
          types: [
            {
              description: 'File',
              accept: {'application/json': ['.lyt']}
            }
          ]
        })
          .then(fileHandle => {
            const writeFile = async (fileHandle, contents) => {
              // Create a FileSystemWritableFileStream to write to.
              const writable = await fileHandle.createWritable()
              // Write the contents of the file to the stream.
              await writable.write(contents)
              // Close the file and write the contents to disk.
              await writable.close()
            }
            // write file
            writeFile(fileHandle, blob).then(() => console.log('FILE DOWNLOADED!!!'))
          })
      } catch (error) {
        console.log(error)
      }
    },
    onImportLayout (event) {
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0]
        file.text()
          .then(resp => {
            const layout = JSON.parse(resp)
            this.params.columnApi.applyColumnState({ state: layout, applyOrder: true })
            event.target.value = null
            this.params.api.closeToolPanel()
          })
      }
    }
  }
}
</script>

<style>
i {
  cursor: pointer;
}

.sidebar-button {
  background-color: #fff !important;
  width: 100%;
  border-radius: 6px;
  border-color: #dae0e5;
  margin-top: 10px;
  font-weight: 500;
  letter-spacing: 0.25px;
  font-size: 0.8rem !important;
}

button.floatButton {
  position: sticky;
  display: block;
  bottom: 2rem;
  padding: 0.8rem;
  border-radius: 50%;
  box-shadow: 1px 1px 3px 0 black;
  margin-left: auto;
  margin-right: 1rem;
  margin-bottom: 1rem;
  margin-top: auto;
}

.sidebar-button:hover {
  background-color: rgb(246, 246, 246) !important;
}

.sidebar-separator {
  text-align: center;
  margin-top: 1rem;
  color: #008143;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.25px;
  padding-bottom: 8px;
  border-bottom: 1px solid #0081435d;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/LayoutSidebar.vue